<template>
  <div>
    <div
      v-if="idps.length"
      class="idp-login-block d-flex flex-column align-center">
      <qx-button
        v-for="idp in idps"
        :id="`idp-${idp.name}`"
        :key="idp.name"
        :title="idp.name"
        :href="`${idp.url}?source=${sourceLocation}`"
        :prevent-default="false"
        target=""
        :is-block="true"
        state="additional"
        class="text-truncate">
        {{ idp.name }}
      </qx-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import qxButton from '@/elements/button.vue';

export default {
  name: 'IdpLoginButtons',
  components: {
    qxButton,
  },
  computed: {
    ...mapState({
      idps: (store) => store.accountData.idps,
    }),
    sourceLocation() {
      return encodeURIComponent(`${window.location.protocol}//${window.location.hostname}${window.location.pathname}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.idp-login-block {
  width: 300px;
}
</style>
